import { FwUser } from '@compassdigital/foodworks.api.ts';
import { User } from '@compassdigital/foodworks.ts.sdk';
import { orderBy } from 'lodash';
import Format from '@/util/Format';
import { IUserTableInfo } from '@/interface/userTableInfo';

export default class UserUtil {
  /**
   * Parses the permission scope and returns available roles
   * @param user
   */
  public static getRoles(user: FwUser) {
    if (user.permissions && user.permissions.scopes) {
      return user.permissions.scopes;
    }
    return [];
  }

  /**
   * Parses the role and returns avatar color
   * @param role
   */
  public static getAvatarColor(role?: string) {
    switch (role) {
      case 'fw_manager':
        return 'secondary';
      case 'fw_admin':
        return 'primary';
      case 'unit_manager':
        return 'tertiary3';
      case 'partner_owner':
        return 'tertiary1';
      default:
        return 'tertiary2';
    }
  }

  /**
   * Parses the role and returns avatar text color
   * @param role
   */
  public static getAvatarTextColor(role?: string) {
    switch (role) {
      case 'fw_admin':
        return 'white--text';
      default:
        return 'primary--text';
    }
  }

  /**
   * Parses the user status and returns user status color
   * @param disabled
   */
  public static getUserStatusColor(status?: string) {
    switch (status) {
      case 'Active':
        return 'green small';
      default:
        return 'small';
    }
  }

  public static RoleMap: { [key: string]: string } = {
    // partner_popup_staff: 'Popup Staff',
    partner_owner: 'Restaurant Partner',
    unit_manager: 'Unit Manager',
    // unit_region_manager: 'Unit Regional Manager',
    // fw_scout: 'Foodworks Scout',
    fw_manager: 'Foodworks Manager',
    fw_admin: 'Administrator',
    // operator: 'Operator',
  }

  /**
   * Parses the role and returns formatted role
   * @param role
   */
  public static getFormatedRole(role?: string) {
    return this.RoleMap[role as string] || '';
  }

  /**
   * Parses the users and return formatted users
   * @param users
   */

  public static getMappedUsers(users: Array<User>): Array<IUserTableInfo> {
    const mappedUsers = !users
      || users.map((user: any) => {
        const {
          id, name, email, title, is, _createdDate,
        } = user;

        let userName = '';
        let disabled = 'Deactivated';
        if (is && is.disabled != null) {
          disabled = is.disabled === false ? 'Active' : 'Deactivated';
        }
        let phoneNumber: any = '';
        let contactNumber: any = '';
        if (user.phone && user.phone.phone) {
          const { phone } = user.phone;
          contactNumber = phone;
          phoneNumber = Format.maskPhoneNumber(phone);
        }
        let avatar = '';
        if (name && name.first && name.last) {
          userName = Format.capitalize(`${String(name.first).trim()} ${String(name.last).trim()}`);
          avatar = name.first[0].toUpperCase() + name.last[0].toUpperCase();
        }
        const userRole = (user.permissions?.scopes[0]) || '';
        return {
          userId: id,
          userName,
          avatar,
          email,
          disabled,
          name,
          phoneNumber,
          contactNumber,
          userRole,
          userFormatedRole: UserUtil.getFormatedRole(userRole),
          userStatusColor: this.getUserStatusColor(disabled),
          avatarColor: UserUtil.getAvatarColor(userRole),
          avatarTextColor: UserUtil.getAvatarTextColor(userRole),
          _createdDate,
        };
      });
    return orderBy(mappedUsers, '_createdDate', 'desc');
  }
}
